// register all components

import './configuratorApp';
import './mainConfigurator';
import './configurationSections';
import './configurationSection';
import './featureContainer';
import './sectionsHead';
import './sectionsTabs';
import './sectionsTab';
import './transLabel';
import './svgIcon';
import './dashboardView';
import './visualPlaceholder';
import './modalView';
import './explainView';
import './languageSwitch';
import './loginPopUp';
import './loginPage';
import './modeSwitch';
import './routerLink';
import './totalPrice';
import './summaryPanel';
import './downloadCSV';
import './shortnumberLoad';
import './specificationIdLoad';
import './toolbarButton';
import './progressBar';
import './progressButton';
import './versionNotice';
import './downloadPanel/downloadPanel';
import './downloadPanel/downloadSidebar';
import './downloadPanel/visualSpecsheet';
import './downloadPanel/visualFinalize';
import './downloadPanel/familySelector';
import './downloadPanel/familyTiles';
import './downloadPanel/familyList';
import './downloadPanel/familyListFilter';
import './downloadPanel/downloadButton';
import './downloadPanel/finalizeCTA';


import './widgets/locationSelect';
import './widgets/verticalSlider';
import './widgets/familySelect';

import './specsheet/specsheetPanel';


// avanza specific components
import './avanza/specsheet/avanzaPageSummary';
import './avanza/specsheet/avanzaPageDataAndText';
import './avanza/specsheet/avanzaTenderText';

// widgets
import './widgets/listSelect';
import './widgets/listSelectItem';
import './widgets/colorSelect';
import './widgets/colorSelectItem';
import './widgets/modelSelect';
import './widgets/modelSelectItem';
import './widgets/textInput';
import './widgets/assistantListSelect';
import './widgets/assistantListSelectItem';
import './widgets/assistantWrapper';
import './widgets/numericRange';

import './sharedSpecsheet/sharedSpecsheetFooter';
import './sharedSpecsheet/sharedSpecsheetHead';
import './sharedSpecsheet/sharedSpecsheetPage';

import './sharedSpecsheet/sharedSpecsheet';
import './sharedSpecsheet/specsheets/newSpecsheet';

import './sharedSpecsheet/familyOverview';
import './sharedSpecsheet/familyOverviewHead';
import './sharedSpecsheet/familyOverviewPage';
import './sharedSpecsheet/modelOverview';
import './sharedSpecsheet/familyTenderText';

import './sharedSpecsheet/sharedTechnicalDataPage';
import './sharedSpecsheet/sharedSpecsheetFeature';
import './sharedSpecsheet/sharedTechnicalData';
import './sharedSpecsheet/sharedTechnicalDataAttributes';

import './sharedSpecsheet/sharedTenderTextPage';
import './sharedSpecsheet/tenderTexts/generalTenderText';
import './sharedSpecsheet/tenderTexts/newLightTenderText';
import './sharedSpecsheet/tenderTexts/lineTenderText';
import './sharedSpecsheet/uspTable';
import './sharedSpecsheet/uspTableItem';
import './sharedSpecsheet/sharedPolarDiagram';
import './sharedSpecsheet/sharedLlmfTable';

import './sharedSpecsheet/tenderTextImages/lightProfileImage';
import './sharedSpecsheet/sharedLightEngine';

import './sharedSpecsheet/modelDataPage';
import './sharedSpecsheet/modelData';

import './sharedSpecsheet/personaliseForm';
import './sharedSpecsheet/personaliseField';

import './spc/spcAttribute';
import './spc/spcChoiceAttribute';
import './spc/spcChoiceAttributeColor';
import './spc/spcChoiceAttributeCombo';
import './spc/spcChoiceValue';
import './spc/spcChoiceValueColor';
import './spc/spcChoiceValueCombo';
import './spc/spcAssistantChoiceAttribute';
import './spc/spcAssistantChoiceValue';
import './spc/spcComponentAttribute';
import './spc/spcComponentValue';
import './spc/spcBooleanAttribute';
import './spc/spcBooleanValue';
import './spc/spcNumericAttribute';
import './spc/spcValuesLabel';
import './spc/spcValuesIcons';

import './attributesView';

import './priceSheet/priceSheet';
import './priceSheet/priceData';

// line
import '../line/components/index';

// solar
import '../solar/components/index';

// olivio
import '../olivio/components/index';

// olivio
import '../lightProfile/components/index';

import './dev-label';
import './line-steel-label';

